module.exports = __webpack_public_path__ + "buy_x.3ba3cd60ad320906069256c2da90b6c6.jpg";